import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import WebsiteDetail from './components/WebsiteDetail';
import PageDetail from './components/PageDetail';
import ClientView from './components/ClientView';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import './index.css';

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <AdminLogin /> : <Navigate to="/admin" />} />
        <Route path="/admin" element={isAuthenticated ? <AdminDashboard /> : <Navigate to="/login" />} />
        <Route path="/admin/website/:id" element={isAuthenticated ? <WebsiteDetail /> : <Navigate to="/login" />} />
        <Route path="/admin/website/:websiteId/page/:pageId" element={isAuthenticated ? <PageDetail /> : <Navigate to="/login" />} />
        <Route path="/client/:shareId" element={<ClientView />} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <AppContent />
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;